import { OutPutResult } from '@operations/shared';
import { useDispatch, useSelector } from 'react-redux';
import { move } from '../../stores/actions';
import { Button } from 'antd';

const CheckUploadedData = () => {
    const users: any = useSelector((state: any) => state.actionsReducer.dataSheet.sheetData);
    const dispatch= useDispatch()
  return (
    <div>
        <>
            <div className="truckUsersSuccess">
                <OutPutResult status={'success'} subTitle={`${users.length} Employee${users.length > 1 ? "s":""} have been uploaded successfully`} title={'Data has been added to the system successfully'} />
                {<Button className='reUpload' onClick={()=>dispatch(move(0))}>Upload another file</Button>}
            </div>
        </>
    </div>
  )
}

export default CheckUploadedData